module.exports = __webpack_public_path__ + "static/logoGif-26d1414450eb7c796f2c8d8cdbcee9a4.gif";